import ReportResultLayout from 'dashboard/components/ReportResult/ReportResultLayout';
import CodeHighlight from 'dashboard/components-lib/CodeHighlight';
import { Report } from 'dashboard/models/report';
import Card from 'design-system/components/Card';

export interface ReportResultIntegrationProps {
  report: Report;
  isRedacted: boolean;
  multiCardFormat: boolean;
}

export const ReportResultIntegration = ({
  report,
  isRedacted,
  multiCardFormat,
}: ReportResultIntegrationProps) => {
  return (
    <ReportResultLayout multiCardFormat={multiCardFormat}>
      <>
        <Card.Title>Results</Card.Title>
        {!isRedacted && (
          <CodeHighlight language='json' rowsToShow={40} light={true}>
            {JSON.stringify((report.attributes as any)?.result, null, 2)}
          </CodeHighlight>
        )}
      </>
    </ReportResultLayout>
  );
};
